import React from "react";

type Props = {};

export const CreatePageMainSection: React.FC<Props> = (props) => {
  return <section>{props.children}</section>;
};

CreatePageMainSection.displayName = "CreatePageMainSection";
